module.exports = __webpack_public_path__ + "img/w5.7d1ed1e5.png";